import { Controller } from "@hotwired/stimulus";
import { LoadingSpinnerHandler } from "@mixins/btnLoading";
import axios from "axios";
import { camelCase } from "lodash-es";
import { tinymceInit } from "@/plugins/tinymce";

let feiLicences = [];
let insurance = null;
let textInputDelay = null;

let eventIdFieldValue = null;

export default class extends Controller {
  static targets = [
    "productInput",
    "feiLicence",
    "personYearlyInsurance",
    "personYearlyInsurancePackage2",
    "productForm",

    "orderItemForm",

    "accordionsOpen",

    "eventForSingleLicence"
  ];

  productFormTargetConnected() {
    tinymceInit({
      toolbar:
        "blocks fontsize | forecolor backcolor | bold italic underline strikethrough | link removeformat"
    });
  }

  orderItemFormTargetConnected(form) {
    // Closing modal should clear out eventIdFieldValue
    document.querySelector("#modal").addEventListener(
      "hide.bs.modal",
      () => {
        eventIdFieldValue = null;
      },
      { once: true }
    );

    form.querySelectorAll("select").forEach(el => {
      window.initSelect2(el);
    });

    const triggerValidation = () => {
      // Prevent creating record if its still valid
      form.querySelector(`[name="order_item[refresh]"]`).value = true;

      const submit = form.querySelector("button[type=submit]");
      submit.disabled = true;
      LoadingSpinnerHandler.add(submit);

      const formData = new FormData(form);

      // Make inputs be disabled to prevent dumb changes.
      form.querySelectorAll("input,select").forEach(el => {
        if (el.type == "text") return;
        el.disabled = true;
      });

      const token = document.getElementsByName("csrf-token");
      axios({
        url: form.action,
        method: "POST",
        headers: {
          "X-CSRF-Token": token[0].content,
          Accept: "text/vnd.turbo-stream.html"
        },
        data: formData
      })
        .then(({ data }) => {
          Turbo.session.receivedMessageFromStream(data);
        })
        .catch(error => {
          console.error(error);
        });
    };

    form
      .querySelectorAll("input[type=radio],input[type=checkbox]")
      .forEach(el => {
        if (el.dataset.ignoreValidation === "true") return;
        el.addEventListener("click", triggerValidation);
      });

    form.querySelectorAll("input[type=text]").forEach(el => {
      if (el.dataset.ignoreValidation === "true") return;
      el.addEventListener("input", () => {
        clearTimeout(textInputDelay);
        textInputDelay = setTimeout(() => triggerValidation(), 2500);
      });
    });

    form.querySelectorAll("select").forEach(el => {
      if (el.dataset.ignoreValidation === "true") return;
      $(el).on("input", triggerValidation); // Only trough jQuery will select2 trigger that input
    });
  }

  insuranceInput(evt) {
    if (evt.target.value && evt.target.value != "on") {
      insurance = camelCase(evt.target.value);
    } else {
      insurance = null;
    }
  }

  feiLicenceInput(evt) {
    if (evt.target.value === "endurance") {
      const targetInput = evt.target.form.querySelector(
        ".order_item_fei_horse_trainer"
      );
      // If does not exist, then exit function
      if (!targetInput) return;
      if (evt.target.checked) {
        targetInput.classList.remove("d-none");
      } else {
        targetInput.classList.add("d-none");
        targetInput.value = "";
      }
    }

    if (evt.target.checked) {
      feiLicences.push(evt.target.value);
    } else {
      feiLicences = feiLicences.filter(x => x != evt.target.value);
    }
  }

  toggleAccordion(evt) {
    const data = evt.target.dataset.rtsAccordionValue;
    const elInput = document.querySelector(`input[name="order_item[${data}]"]`);

    if (elInput.value === "0") elInput.value = "1";
    else elInput.value = "0";
  }

  eventForSingleLicenceTargetConnected(element) {
    window.initSelect2(element);

    function updateSelectOptions() {
      const disciplineId =
        $("[data-event-id-discipline-filter]").val() || undefined;

      const params = new URLSearchParams();
      if (disciplineId) {
        params.append("discipline_id", disciplineId);
      }

      axios({
        method: "GET",
        url: element.dataset.url + "?" + params.toString(),
        headers: {
          Accept: "application/json"
        }
      }).then(({ data }) => {
        // force clear
        $(element)
          .find("option")
          .each(function () {
            this.remove();
          });
        $(element).select2({
          data: data.results
        });

        $(element).val(eventIdFieldValue).trigger("change");
      });
    }

    $("[data-event-id-discipline-filter]").on("change", evt => {
      $(element).val(null).trigger("change");
      updateSelectOptions();
    });

    updateSelectOptions();

    $(element).on("select2:select", evt => {
      eventIdFieldValue = evt.params.data.id;
    });
  }
}
